import { render, staticRenderFns } from "./DeliveryApp.vue?vue&type=template&id=00fe5f9c&scoped=true&"
import script from "./DeliveryApp.vue?vue&type=script&lang=js&"
export * from "./DeliveryApp.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryApp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DeliveryApp.vue?vue&type=style&index=1&id=00fe5f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe5f9c",
  null
  
)

export default component.exports